import styled from "styled-components";

export const Content = styled.main`
  padding-top: 60px;
`;
